module.exports = __webpack_public_path__ + "img/bh.8d1eb25f.png";